function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module image/imageresize/imageresizebuttons
 */
import { Plugin, icons } from 'ckeditor5/src/core';
import { ButtonView, DropdownButtonView, Model, createDropdown, addListToDropdown } from 'ckeditor5/src/ui';
import { CKEditorError, Collection } from 'ckeditor5/src/utils';
import ImageResizeEditing from './imageresizeediting';
var RESIZE_ICONS = {
  small: icons.objectSizeSmall,
  medium: icons.objectSizeMedium,
  large: icons.objectSizeLarge,
  original: icons.objectSizeFull
};
/**
 * The image resize buttons plugin.
 *
 * It adds a possibility to resize images using the toolbar dropdown or individual buttons, depending on the plugin configuration.
 *
 * @extends module:core/plugin~Plugin
 */

var ImageResizeButtons =
/*#__PURE__*/
function (_Plugin) {
  _inherits(ImageResizeButtons, _Plugin);

  _createClass(ImageResizeButtons, null, [{
    key: "requires",

    /**
     * @inheritDoc
     */
    get: function get() {
      return [ImageResizeEditing];
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "pluginName",
    get: function get() {
      return 'ImageResizeButtons';
    }
    /**
     * @inheritDoc
     */

  }]);

  function ImageResizeButtons(editor) {
    var _this;

    _classCallCheck(this, ImageResizeButtons);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImageResizeButtons).call(this, editor));
    /**
     * The resize unit.
     *
     * @readonly
     * @private
     * @type {module:image/image~ImageConfig#resizeUnit}
     * @default '%'
     */

    _this._resizeUnit = editor.config.get('image.resizeUnit');
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImageResizeButtons, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var options = editor.config.get('image.resizeOptions');
      var command = editor.commands.get('resizeImage');
      this.bind('isEnabled').to(command);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var option = _step.value;

          this._registerImageResizeButton(option);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this._registerImageResizeDropdown(options);
    }
    /**
     * A helper function that creates a standalone button component for the plugin.
     *
     * @private
     * @param {module:image/imageresize/imageresizebuttons~ImageResizeOption} resizeOption A model of the resize option.
     */

  }, {
    key: "_registerImageResizeButton",
    value: function _registerImageResizeButton(option) {
      var _this2 = this;

      var editor = this.editor;
      var name = option.name,
          value = option.value,
          icon = option.icon;
      var optionValueWithUnit = value ? value + this._resizeUnit : null;
      editor.ui.componentFactory.add(name, function (locale) {
        var button = new ButtonView(locale);
        var command = editor.commands.get('resizeImage');

        var labelText = _this2._getOptionLabelValue(option, true);

        if (!RESIZE_ICONS[icon]) {
          /**
           * When configuring {@link module:image/image~ImageConfig#resizeOptions `config.image.resizeOptions`} for standalone
           * buttons, a valid `icon` token must be set for each option.
           *
           * See all valid options described in the
           * {@link module:image/imageresize/imageresizebuttons~ImageResizeOption plugin configuration}.
           *
           * @error imageresizebuttons-missing-icon
           * @param {module:image/imageresize/imageresizebuttons~ImageResizeOption} option Invalid image resize option.
          */
          throw new CKEditorError('imageresizebuttons-missing-icon', editor, option);
        }

        button.set({
          // Use the `label` property for a verbose description (because of ARIA).
          label: labelText,
          icon: RESIZE_ICONS[icon],
          tooltip: labelText,
          isToggleable: true
        }); // Bind button to the command.

        button.bind('isEnabled').to(_this2);
        button.bind('isOn').to(command, 'value', getIsOnButtonCallback(optionValueWithUnit));

        _this2.listenTo(button, 'execute', function () {
          editor.execute('resizeImage', {
            width: optionValueWithUnit
          });
        });

        return button;
      });
    }
    /**
     * A helper function that creates a dropdown component for the plugin containing all the resize options defined in
     * the editor configuration.
     *
     * @private
     * @param {Array.<module:image/imageresize/imageresizebuttons~ImageResizeOption>} options An array of configured options.
     */

  }, {
    key: "_registerImageResizeDropdown",
    value: function _registerImageResizeDropdown(options) {
      var _this3 = this;

      var editor = this.editor;
      var t = editor.t;
      var originalSizeOption = options.find(function (option) {
        return !option.value;
      });

      var componentCreator = function componentCreator(locale) {
        var command = editor.commands.get('resizeImage');
        var dropdownView = createDropdown(locale, DropdownButtonView);
        var dropdownButton = dropdownView.buttonView;
        dropdownButton.set({
          tooltip: t('Resize image'),
          commandValue: originalSizeOption.value,
          icon: RESIZE_ICONS.medium,
          isToggleable: true,
          label: _this3._getOptionLabelValue(originalSizeOption),
          withText: true,
          "class": 'ck-resize-image-button'
        });
        dropdownButton.bind('label').to(command, 'value', function (commandValue) {
          if (commandValue && commandValue.width) {
            return commandValue.width;
          } else {
            return _this3._getOptionLabelValue(originalSizeOption);
          }
        });
        dropdownView.bind('isOn').to(command);
        dropdownView.bind('isEnabled').to(_this3);
        addListToDropdown(dropdownView, _this3._getResizeDropdownListItemDefinitions(options, command));
        dropdownView.listView.ariaLabel = t('Image resize list'); // Execute command when an item from the dropdown is selected.

        _this3.listenTo(dropdownView, 'execute', function (evt) {
          editor.execute(evt.source.commandName, {
            width: evt.source.commandValue
          });
          editor.editing.view.focus();
        });

        return dropdownView;
      }; // Register `resizeImage` dropdown and add `imageResize` dropdown as an alias for backward compatibility.


      editor.ui.componentFactory.add('resizeImage', componentCreator);
      editor.ui.componentFactory.add('imageResize', componentCreator);
    }
    /**
     * A helper function for creating an option label value string.
     *
     * @private
     * @param {module:image/imageresize/imageresizebuttons~ImageResizeOption} option A resize option object.
     * @param {Boolean} [forTooltip] An optional flag for creating a tooltip label.
     * @returns {String} A user-defined label combined from the numeric value and the resize unit or the default label
     * for reset options (`Original`).
     */

  }, {
    key: "_getOptionLabelValue",
    value: function _getOptionLabelValue(option, forTooltip) {
      var t = this.editor.t;

      if (option.label) {
        return option.label;
      } else if (forTooltip) {
        if (option.value) {
          return t('Resize image to %0', option.value + this._resizeUnit);
        } else {
          return t('Resize image to the original size');
        }
      } else {
        if (option.value) {
          return option.value + this._resizeUnit;
        } else {
          return t('Original');
        }
      }
    }
    /**
     * A helper function that parses the resize options and returns list item definitions ready for use in the dropdown.
     *
     * @private
     * @param {Array.<module:image/imageresize/imageresizebuttons~ImageResizeOption>} options The resize options.
     * @param {module:image/imageresize/resizeimagecommand~ResizeImageCommand} command The resize image command.
     * @returns {Iterable.<module:ui/dropdown/utils~ListDropdownItemDefinition>} Dropdown item definitions.
     */

  }, {
    key: "_getResizeDropdownListItemDefinitions",
    value: function _getResizeDropdownListItemDefinitions(options, command) {
      var _this4 = this;

      var itemDefinitions = new Collection();
      options.map(function (option) {
        var optionValueWithUnit = option.value ? option.value + _this4._resizeUnit : null;
        var definition = {
          type: 'button',
          model: new Model({
            commandName: 'resizeImage',
            commandValue: optionValueWithUnit,
            label: _this4._getOptionLabelValue(option),
            withText: true,
            icon: null
          })
        };
        definition.model.bind('isOn').to(command, 'value', getIsOnButtonCallback(optionValueWithUnit));
        itemDefinitions.add(definition);
      });
      return itemDefinitions;
    }
  }]);

  return ImageResizeButtons;
}(Plugin); // A helper function for setting the `isOn` state of buttons in value bindings.


export { ImageResizeButtons as default };

function getIsOnButtonCallback(value) {
  return function (commandValue) {
    if (value === null && commandValue === value) {
      return true;
    }

    return commandValue && commandValue.width === value;
  };
}
/**
 * The image resize option used in the {@link module:image/image~ImageConfig#resizeOptions image resize configuration}.
 *
 * @typedef {Object} module:image/imageresize/imageresizebuttons~ImageResizeOption
 * @property {String} name The name of the UI component that changes the image size.
 * * If you configure the feature using individual resize buttons, you can refer to this name in the
 * {@link module:image/image~ImageConfig#toolbar image toolbar configuration}.
 * * If you configure the feature using the resize dropdown, this name will be used for a list item in the dropdown.
 * @property {String} value The value of the resize option without the unit
 * ({@link module:image/image~ImageConfig#resizeUnit configured separately}). `null` resets an image to its original size.
 * @property {String} [resizeOptions.icon] An icon used by an individual resize button (see the `name` property to learn more).
 * Available icons are: `'small'`, `'medium'`, `'large'`, `'original'`.
 * @property {String} [label] An option label displayed in the dropdown or, if the feature is configured using
 * individual buttons, a {@link module:ui/button/buttonview~ButtonView#tooltip} and an ARIA attribute of a button.
 * If not specified, the label is generated automatically based on the `value` option and the
 * {@link module:image/image~ImageConfig#resizeUnit `config.image.resizeUnit`}.
 */